import * as React from 'react';

import {FormWidget, FormConfigurations} from 'kiini/Forms';
import GeoFenceWidget from './GeoFenceWidget';
import TextField from 'kiini/TextField';

const formConfigurationData = {
       "content_objects.model.GeoTrigger": {
        groups:  [
            {
                    label: "Triggering",
                    fields: [
                        { fieldName: "name", label: "Name", widget: TextField },
                        {fieldName: "geoFence", label: "Trigger circle radius", widget: GeoFenceWidget}
                    ]   
            },
        ]
    }
}

const formConfiguration = new FormConfigurations(formConfigurationData);

const IndependentGeoTriggerForm = ({instance, experienceEditorStore}) => {


    return <React.Fragment>
        <FormWidget instance={instance} formConfigurations={formConfiguration} store={experienceEditorStore}/>
        
    </React.Fragment> 
}


export default IndependentGeoTriggerForm;